import { createContext, useContext, type Context } from 'react';

import type { SpaceDetail_space$data } from './__generated__/SpaceDetail_space.graphql.ts';

type SharedSpaceDetail = {
	spaceKey: string;
	loading: boolean;
	space?: SpaceDetail_space$data;
};

export const SpaceDetailContext: Context<SharedSpaceDetail | undefined> = createContext<
	SharedSpaceDetail | undefined
>(undefined);

export const useSpaceDetailContext = (): SharedSpaceDetail | undefined =>
	useContext(SpaceDetailContext);
